"use client";
import { useLoading } from "@/contexts/LoadingContext";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { DialogDemo } from "@/components/dialogs/Dialog-ai";
import { FC, useEffect, useState } from "react";
import { Sidebar, SidebarBody, SidebarLink } from "@/components/ui/sidebar";
import { cn } from "@/lib/utils";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { motion } from "framer-motion";
import logoBMP from "../../assets/logo.svg";
import favIcon from "../../../public/favicon.svg";
import TypographyH1 from "@/components/typography/TypographyH1";
import { ChevronDown, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { GiHamburgerMenu } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { User } from "@/features/auth/types";
import { logoutUser, setUser, toggleQuestion } from "@/features/auth/UserSlice";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/collapsible";
// import {  UserDetails } from "@/features/user-profile/services/userProfileServices";
// import MiddleTopBar from "./topbar-center-prompt";

export type IPrompts = Array<{
  title: string;
  description: string;
}>;
export interface SidebarDemoProps {
  navLinks: Array<{
    label: string;
    href?: string; // href is optional because parent items (like Documents) don't have a link
    onClick?: () => void; // onClick is optional for parent items
    icon?: React.ReactNode;
    children?: Array<{
      label: string;
      href: string;
      icon?: React.ReactNode;
    }>;
  }>;
  prompts?: IPrompts;
}

export const SideNavMenu: FC<SidebarDemoProps> = ({ navLinks, prompts }) => {
  const [isSidenavOpen, toggleSidenav] = useState<boolean>(true);
  const [showMessage, setShowMessage] = useState(true);
  const [aiDialogOpen, setAIDialogOpen] = useState<boolean>(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );

  useEffect(() => {
    const interval = setTimeout(() => {
      setShowMessage(false);
    }, 10000);

    return () => clearTimeout(interval);
  }, []);

  useEffect(() => {
    const dialogState = searchParams.get("dialog");
    if (dialogState && dialogState == "open") {
      setAIDialogOpen(true);
      searchParams.delete("dialog");
      setSearchParams(searchParams);
    }
  }, []);

    const navigate = useNavigate();

  const toggleOpen = () => {
    console.log("toggle open clicked", isSidenavOpen);
    toggleSidenav(!isSidenavOpen);
  };

  // useEffect(() => {
  //   console.log("side bar state changed", isSidenavOpen);
  // }, [isSidenavOpen]);

  const location = useLocation();
  const shouldShowDialog = location.pathname !== "/dashboard/buildmapper_agent" && location.pathname !== "/dashboard/analytics" && location.pathname !== "/dashboard/CRM/configurations" && location.pathname !== "/dashboard/all_apps" && location.pathname !== "/dashboard/integration" && location.pathname !== "dashboard/contacts" && location.pathname !== "/dashboard/quotes" && location.pathname !== "/dashboard/contracts" && location.pathname !== "/dashboard/invoicing" && location.pathname !== "/dashboard/automation" && location.pathname !== "/dashboard/contacts" && location.pathname !== "/profile/organization-users" && location.pathname !== "/profile/email-templates" && location.pathname !== "/profile/company-profile/edit" && location.pathname !== "/profile/company-profile" && location.pathname !== "/profile/company-profile/add-new-project" && location.pathname !== "/profile/company-profile/sharable" && location.pathname !== "/profile/company-profile/builder-project/edit" && location.pathname !== "/profile/company-profile/add";

  return (
    <div
      className={cn(
        "rounded-md flex flex-col md:flex-row  flex-1 border border-neutral-200 dark:border-neutral-700 overflow-hidden",
        "h-screen" // for your use case, use `h-screen` instead of `h-[60vh]`
      )}
    >
      <Sidebar open={isSidenavOpen} setOpen={toggleSidenav} animate={true}>
        <SidebarHeader open={isSidenavOpen} prompts={prompts} />
        <SidebarBody className="relative justify-between gap-10 !bg-[#fbfbfb] border-r border-[#e4e4e4]">
          <Button
            type="button"
            size="icon"
            onClick={toggleOpen}
            className="cursor-pointer z-[50] !bg-[#f2f2f2] flex items-center justify-center absolute right-[-14px] size-[28px]"
          >
            {isSidenavOpen ? (
              <PanelLeftClose className="text-gray-500" size={20} />
            ) : (
              <PanelLeftOpen className="text-gray-500" size={20} />
            )}
          </Button>
          <div className="flex flex-col flex-1 mt-5  overflow-x-hidden">
            {/* {open ? <Logo /> : <LogoIcon />} */}
            {/* <Logo /> */}
            <ScrollArea className="">
              <div className="pr-4">


              
              <div className="mt-8 flex flex-col gap-[10px]">
               
                {navLinks.map((link, idx) => (
                  
                  <div key={idx}>
                    {/* If link has children, show a collapsible */}
                    
                    {link.children ? (
                      <Collapsible>
                        <CollapsibleTrigger asChild>
                          <button className="flex items-center justify-between w-full px-3 py-2 rounded text-[14px] font-medium text-[#404040] hover:bg-gray-100">
                            <div className={`${isSidenavOpen ? "gap-3" : "gap-7"} flex items-center`}>
                              {link.icon}
                              <span>{link.label}</span>
                            </div>
                            <ChevronDown className="w-4 h-4 " />
                          </button>
                        </CollapsibleTrigger>
                        <CollapsibleContent
                          className={`${isSidenavOpen ? "ml-[1.15rem]" : "ml-0"} flex flex-col gap-2`}
                        >
                          {link.children.map((child, childIdx) => (
                            <SidebarLink
                              key={childIdx}
                              link={child}
                              className={`flex items-center gap-3 px-3 py-2 rounded text-[14px] font-medium ${location.pathname.includes(child.href)
                                  ? "bg-[#f2f2f2] text-black"
                                  : "text-[#727272] hover:bg-gray-100"
                                }`}
                              labelVisible={isSidenavOpen}
                              // user={user?.is_crm_user ? { is_crm_user: user.is_crm_user } : undefined}
                              user={
                                child.href === "user-profile" || user?.is_crm_user
                                  ? { is_crm_user: true }
                                  : undefined
                              }
                            />
                          ))}
                        </CollapsibleContent>
                      </Collapsible>
                    ) :(
                      <SidebarLink
                        key={idx}
                          onClick={
    link.label === "My Account"
      ? () => navigate("/dashboard/explore_leads")
      : link.onClick
  }
                        link={link}
                        className={`flex items-center gap-3 px-3 py-2
                          rounded text-[14px] font-medium
                          ${
                            link.label === "Logout"
                              ? "text-[#727272] hover:bg-gray-100" // No bg unless hovered
                              : location.pathname.includes(link.href ?? "")
                              ? "bg-[#f2f2f2] text-black"
                              : "text-[#727272] hover:bg-gray-100"
                          }`}
                        
                        labelVisible={isSidenavOpen}
                        // user={user?.is_crm_user ? { is_crm_user: user.is_crm_user } : undefined}
                        user={
                          link.label === "User Profile"  ||link.label ==="Lead Data" || user?.is_crm_user
                            ? { is_crm_user: true }
                            : undefined
                        }
                        
                      />
                      
                    
                  )}
                  </div>
                ))}
              </div>
              </div>
              <ScrollBar className="" />
            </ScrollArea>
          </div>

        </SidebarBody>

        <section className="w-full flex flex-col mt-[55px] overflow-hidden bg-white">
          <ScrollArea className="h-full w-full ">
            <Outlet />
            <ScrollBar />
          </ScrollArea>
        </section>
        <div className="fixed bottom-5 right-5 z-50">
          <Popover open={true}>
            <PopoverTrigger>
              {shouldShowDialog && (
                <DialogDemo
                  open={aiDialogOpen}
                  showAIDialog={setAIDialogOpen}
                  prompts={prompts ?? []}
                />
              )}
            </PopoverTrigger>

            {shouldShowDialog && showMessage && (
              <PopoverContent
                className="bg-gray-100 shadow-sm w-fit"
                align="end"
                alignOffset={20}
              >
                <motion.p
                  className="font-medium"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                  transition={{ duration: 0.5 }}
                >
                  Hi, I’m Rex! Let me help you.
                </motion.p>
              </PopoverContent>
            )}
          </Popover>
        </div>
      </Sidebar>
    </div>
  );
};

const SidebarHeader = ({ open }: { open: boolean; prompts?: IPrompts }) => {
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );

  const [crmUser, setCRMUser] = useState<User | null>(user);

  const dispatch = useDispatch<AppDispatch>();
  const { setLoading } = useLoading();

  const location = useLocation();

  const navigate = useNavigate();

  const goToCRMConfig = () => {
    navigate("/dashboard/CRM/configurations"); // Change this to your actual route
  };

  useEffect(() => {
    // console.log("user", user);
    // if (user) {
    //   //   const name = user.email?.split("@")[0];
    //   setCRMUser(user);
    // } else {
    const localUser = JSON.parse(localStorage.getItem("user") + "");
    if (localUser) {
      console.log("local user", localUser);
      dispatch(setUser(localUser));
      const questionDone = localStorage.getItem("questionDone");
      if (questionDone) {
        dispatch(toggleQuestion(questionDone == "true"));
      }
    }
    // }
  }, []);


    //  const userDetailsSelector = useSelector(
    //   (state: RootState) => state.rootReducer.userDetailsReducer.userDetails
    // );

  useEffect(() => {
    console.log("user", user);
    if (user) {
      //   const name = user.email?.split("@")[0];
      setCRMUser(user);
    } else {
      const localUser = JSON.parse(localStorage.getItem("user") + "");
      if (localUser) {
        console.log("local user", localUser);
        dispatch(setUser(localUser));
        const questionDone = localStorage.getItem("questionDone");
        if (questionDone) {
          dispatch(toggleQuestion(questionDone == "true"));
        }
      }
    }
  }, [user, dispatch]);

  console.log("user name", crmUser);

  const logout = () => {
    try {
      setLoading(true);
      dispatch(logoutUser()).then(() => {
        console.log("clicked");
        navigate(`/`);
        window.location.reload();
      });
    } finally {
      setLoading(false);
    }
  };
  const currentPath = location.pathname.split("/")[2]?.toLowerCase() || "";
  const currentPathCompanyProfile = location.pathname

  console.log(currentPathCompanyProfile, "line 287")

  // const displayTitle =
  // currentPathCompanyProfile === "/profile/company-profile/edit"
  //   ? "Edit Company Profile Details"
  //   : currentPath === "explore_leads"
  //     ? "Lead Data"
  //     : currentPath === "buildmapper_agent"
  //       ? "BuildMapper Agent"
  //       : currentPath;
  const displayTitle =

  currentPathCompanyProfile === "/profile/company-profile/edit"
    ? "Edit Company Profile Details"
    : currentPathCompanyProfile === "/profile/company-profile/add-new-project"
      ? "Add Builder Project"
      : currentPathCompanyProfile === "/profile/company-profile/add"
        ? "Add Company Profile"
        : currentPathCompanyProfile === "/profile/company-profile/builder-project/edit"
          ? "Edit Builder Project Details"
          : currentPathCompanyProfile === "/profile/company-profile"
            ? "Company Profile"
            : currentPath === "explore_leads"
              ? "Lead Data"
              : currentPath === "buildmapper_agent"
                ? "BuildMapper Agent"
                : currentPath === "company-profile" ? "Company Profile" : currentPath === "user-profile"
                  ? "User Profile" : currentPath === "organization-users"
                    ? "Organization Users": currentPath === "subscription" ? "Subscriptions":currentPath === "email-templates" ? "Email Template"
                    : currentPath === "account-setting" ? "Account Setting": currentPath ==="builder-watchlist" ? "Builder Watchlist": currentPath;





  console.log(currentPath, "Current Path")

  return (
    <div className="absolute w-screen z-50 border-b pb-0 !bg-transparent h-[55px] flex items-center justify-between px-4">
      <div className="flex items-center w-[50%] bg-white">
        <div className=" bg-white  h-[54px]  ">
          {open ? <Logo /> : <LogoIcon />}
        </div>

        <div className="flex items-center gap-3 ml-[50px]">
          <TypographyH1
            className={`!text-[22px] font-medium ${displayTitle == "crm" ? "uppercase" : "capitalize"
              }`}
          >
            {displayTitle !== "404"
              ? displayTitle.replace("_", " ")
              : "Coming Soon"}
          </TypographyH1>

          {/* Show Button only on CRM screen */}
          {location.pathname.toLowerCase().includes("/dashboard/crm") && (
            <Button
              size="sm"
              variant="ghost"
              onClick={goToCRMConfig}
              className={`relative ${location.pathname === "/dashboard/CRM/configurations" ? "border-black font-bold" : ""}`}
            >
              Configurations
            </Button>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1">
        {/* <div className="pr-3" >
          <MiddleTopBar />
        </div> */}

        {/* <div className="border h-[35px] w-[1px] mx-1"></div>
        <div>
          <DialogDemo prompts={prompts ?? []} />
        </div> */}
        {/* <div className="border h-[35px] w-[1px] mx-1"></div> */}

        {(location.pathname.includes("CRM") ||
          location.pathname.includes("leads/")) && (
            <Link to="/dashboard/explore_leads" className="!no-underline">
              <Button
                variant="ghost"
                className="text-bmpGreen-800 px-1"
                size="sm"
              >
                Switch to Explore Leads
              </Button>
            </Link>
          )}
        {location.pathname.includes("explore") && (
          <Link to="/dashboard/CRM" className="!no-underline">
            <Button
              variant="ghost"
              className="text-bmpGreen-800 px-1"
              size="sm"
            >
              Switch to CRM
            </Button>
          </Link>
        )}

        <div className="border h-[35px] w-[1px] mx-1"></div>

        <DropdownMenu>
          <DropdownMenuTrigger className="border-none outline-none">
            <div className="flex gap-2 items-center justify-center border rounded-md py-1 px-2 cursor-pointer   ">
              <div>
                {crmUser?.user_avatar ? (
                  <div className="size-7 rounded-full">
                    <img
                      className="rounded-full"
                      src={`data:image/svg+xml;base64,${crmUser.user_avatar}`}
                      alt=""
                      onError={(e) => {
                        const target = e.target as HTMLImageElement & { _fallbackTried?: boolean };

                        if (!target._fallbackTried) {
                          target._fallbackTried = true;
                          target.onerror = null; // prevent infinite loop
                          target.src = `data:image/svg;base64,${crmUser.user_avatar}`; // retry without +xml
                        }
                      }}
                    />

                  </div>
                ) : (
                  <div className="size-7 rounded-full align-middle uppercase !bg-charcoal text-white flex items-center justify-center">
                    <span>
                      {crmUser?.email ? crmUser.email.substring(0, 2) : "-"}
                    </span>
                  </div>
                )}
              </div>
              <span className="capitalize">
              
                {/* {crmUser?.email ? crmUser.email.split("@")[0] : "-"} */}
           
                {crmUser?.fullName
                  ? crmUser.fullName
                  : crmUser?.email ?
                    crmUser.email.split("@")[0] : "-"}
        
              </span>
              <GiHamburgerMenu className="text-[20px]" />
            </div>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-52 z-[1000] mr-5">
            <DropdownMenuLabel className="text-charcoal text-[16px]">
              My Account
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              className="text-charcoal text-[16px]"
              // onSelect={() => navigate("/my-account")} // Navigate on click
              onSelect={() => navigate("/profile/user-profile")} // Navigate on click
            >
              Settings
            </DropdownMenuItem>
            {/* <DropdownMenuItem className="text-charcoal text-[16px]">
              My Leads
            </DropdownMenuItem> */}
            <DropdownMenuItem
              onClick={logout}
              className="text-charcoal text-[16px]"
            >
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export const Logo = () => {
  return (
    <Link
      to="/"
      className="font-normal flex space-x-2 items-center w-[210px] text-sm text-black py-1 relative z-20"
    >
      {/* <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm flex-shrink-0" /> */}
      <motion.span
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="font-medium text-black dark:text-white whitespace-pre"
      >
        <img src={logoBMP} className="w-full" alt="bmp-logo" />
      </motion.span>
    </Link>
  );
};
export const LogoIcon = () => {
  return (
    <Link
      to="/"
      className="font-normal flex space-x-2 items-center text-sm text-black py-2.5 relative mr-4 z-20"
    >
      {/* <div className="h-5 w-6 bg-black dark:bg-white rounded-br-lg rounded-tr-sm rounded-tl-lg rounded-bl-sm flex-shrink-0" /> */}
      <img src={favIcon} className="w-8" alt="bmp-logo" />
    </Link>
  );
};
